import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-case-communication',
    templateUrl: './case-communication.component.html',
    styleUrls: ['./case-communication.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CaseCommunicationComponent implements OnInit {
  static readonly componentName = 'CaseCommunicationComponent';
  
  constructor() { }

  ngOnInit(): void {
  }

}
